import React from 'react';
import { View, Text, RefreshControl, StyleSheet, Platform, ScrollView, Dimensions, TouchableOpacity } from 'react-native';
import { FlashList } from '@shopify/flash-list';
import CS from '../../constants/Styles';
import { BackgroundGradient, SafeAreaView, Loader } from '../../components';
import * as rtApi from '../../components/Api';
import Colors from '../../constants/Colors';
import ProjectPreview from '../../components/Projects/ProjectPreview';
import { useFocusEffect } from '@react-navigation/native';
import UserState from '../../src/contexts/UserState';
import { useLinkTo } from '@react-navigation/native';
import { FontAwesome5 } from '@expo/vector-icons';

export default function CompletedProjects({ navigation }) {
  const [user, setUser] = React.useContext(UserState);
  const [projects, setProjects] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [isTablet, setIsTablet] = React.useState(false);
  const [isWeb, setIsWeb] = React.useState(Platform.OS === 'web');

  let scrollRef = React.useRef(null);
  const screenWidth = Dimensions.get('window').width;
  const linkTo = useLinkTo();

  useFocusEffect(
    React.useCallback(() => {
      getProjects();
      navigation.setOptions({ title: "Completed Projects" });
    }, [])
  );

  const getProjects = async () => {
    console.log('getProjects CompletedProjectsScreen: ');
    setLoading(true);
    rtApi.get(`agreements`)
      .then(data => {
        if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
        let projects = data.agreements.filter(p => {
          return p.stage === 'Completed';
        });
        setProjects(projects);
      })
      .catch((err) => {
        console.log('getProjects catch', err);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      linkTo(`/projects`);
    }
  }

  return (
    <SafeAreaView style={CS.safe}>
      <BackgroundGradient />
      {Platform.OS === 'web' ?
        <Loader animating={loading} />
        : null}
      <View style={CS.innerContainer}>
        <ScrollView keyboardShouldPersistTaps='handled' ref={scrollRef} style={styles.container} contentContainerStyle={styles.innerContainer}>
          <View style={styles.titleContainer}>
            <Text style={[CS.mediumTitle, CS.lightText, CS.centerText, CS.noMargin]}>Completed Projects</Text>
            <TouchableOpacity onPress={goBack} style={styles.backArrow}>
              <FontAwesome5 name="arrow-left" size={24} color="white" />
            </TouchableOpacity>
          </View>
          {/* <Text style={[CS.largeText, CS.lightText, CS.centerText, CS.boldText, { marginVertical: 10 }]}>Completed Projects</Text> */}
          <FlashList
            data={projects}
            renderItem={({ item }) => <ProjectPreview project={item} />}
            ItemSeparatorComponent={() => (<View style={{ height: 10 }} />)}
            keyExtractor={item => item.id.toString()}
            // ListHeaderComponent={newProjectContainer}
            // ListFooterComponent={completedProjectsComponent}
            refreshControl={<RefreshControl refreshing={loading} onRefresh={() => getProjects()} colors={[Colors.yellow]} tintColor={Colors.yellow} />}
            ListEmptyComponent={() => <Text style={[CS.smallText, CS.lightBlueText, CS.centerText]}>You have no completed projects.</Text>}
            numColumns={((isTablet || isWeb) && screenWidth >= 768) ? 2 : 1}
            // numColumns={2}
            horizontal={false}
            columnWrapperStyle={((isTablet || isWeb) && screenWidth >= 768) && { flex: 1, justifyContent: 'flex-start' }}
          />
        </ScrollView>
      </View>
    </SafeAreaView>
  );

}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    // marginVertical: 10,
    // backgroundColor: 'pink'
  },
  innerContainer: {
    width: '100%',
    // backgroundColor: 'blue',
    // maxWidth: Platform.OS === 'web' ? 768 : '100%',
    // justifyContent: Platform.OS === 'web' ? 'center' : 'flex-start',
    flexGrow: 1,
    alignSelf: 'center',
  },
  newProjectContainer: {
    flexDirection: 'row',
    // alignItems: 'center',
    // justifyContent: 'flex-end',
    marginBottom: 10,
  },
  selectContainer: {
    flex: 1,
    marginRight: 10,
    marginTop: 10,
  },
  inviteNoticeContainer: {
    padding: 10,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: Colors.lightBlue2,
    // borderColor: Colors.yellow,
    backgroundColor: Colors.textInputBackground,
    marginBottom: 20,
  },
  titleContainer: {
    marginVertical: 10
  },
  backArrow: {
    position: 'absolute',
    top: 5,
    left: 0,
  },
});